import React from "react";
import { Box } from "@mui/material";
import { DishList } from "@/components/organisms/DishList";
import { useRenderPerformance } from "@/components/utils/performance";
import { useAppSelector } from "@/core/hooks";

/**
 * Preorder Page Component
 *
 * Simple page that displays the DishList component using brandId and pointId
 * from Redux state. DataLoader handles URL parameter extraction and initialization.
 */
export const PreorderPage: React.FC = () => {
  useRenderPerformance("PreorderPage");

  // Get parameters from Redux state (initialized by DataLoader)
  const { brandId, pointId } = useAppSelector((state) => state.app);

  // If required parameters are missing, show error message
  if (!brandId || !pointId) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          p: 3,
          textAlign: "center",
        }}
      >
        <Box>
          <h2>Ошибка параметров</h2>
          <p>Не указаны обязательные параметры brandId и pointId</p>
          <p>Пример: /preorder?brandId=your-brand-id&pointId=your-point-id</p>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "background.default",
      }}
    >
      <DishList showCategoryNavigation={true} data-testid="preorder-dishlist" />
    </Box>
  );
};
